export enum CacheStoreKey {
    // This file's copy is used in BE
    metaModelDBStamp = 'metaModelDBStamp',
    metaBrandDBStamp = 'metaBrandDBStamp',
    metaAreaDBStamp = 'metaAreaDBStamp',

    // User Model Related
    userCacheStampVehicles = 'userCacheStampVehicles',
    userCacheStampParts = 'userCacheStampParts',
    userCacheStampRecords = 'userCacheStampRecords',
    userCacheStamp = 'userCacheStamp',

    // allResetExceptUserStamp = 'allResetExceptUserStamp'
    noCache = 'noCache'
  }
  